import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Content } from './models/flyout-search.interface';

@Component({
  selector: 'idp-flyout-search',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './flyout-search.component.html',
  styleUrls: ['./flyout-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FlyoutSearchComponent implements OnChanges {
  @Input() content = {} as Content;
  @Input() displayFlyout = false;
  @Input() footerFlyoutSearch = false;
  /** Filtered autocomplete suggestions passed from the smart layer */
  @Input() autocompleteSuggestions: string[] = [];

  @Output() searchValue = new EventEmitter<string>();
  @Output() submitTerm = new EventEmitter<string>();
  @Output() closeFlyoutSearch = new EventEmitter();
  @Output() selectValue = new EventEmitter<string>();
  @Output() suggestionSelected = new EventEmitter<string>();

  searchTerm = '';
  showDropdown = false;

  ngOnChanges(): void {
    if (this.displayFlyout) {
      this.setFocus();
    }
  }

  onSearchInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.searchTerm = value;
    this.showDropdown = true;
    this.searchValue.emit(value);
  }

  onClearSearch(): void {
    this.searchTerm = '';
    this.showDropdown = false;
    this.content.formGroup?.get('searchInput')?.reset();
    this.searchValue.emit('');
  }

  onInputFocus(): void {
    this.showDropdown = true;
  }

  onInputBlur(): void {
    setTimeout(() => (this.showDropdown = false), 200);
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.showDropdown = false;
    }
  }

  selectQuestion(question: string): void {
    this.searchTerm = question;
    this.showDropdown = false;
    this.suggestionSelected.emit(question);
  }

  submitSearch(): void {
    if (!this.searchTerm) return;
    this.submitTerm.emit(this.searchTerm);
  }

  getSelectedValue(url: string): void {
    this.selectValue.emit(url);
  }

  setFocus(): void {
    setTimeout(() => {
      const input = document.querySelector(
        '#site-search-input'
      ) as HTMLInputElement;
      input?.focus();
    }, 0);
  }
}
